export const HeaderElements = {
  BACK_BUTTON: 'back_button',
  TITLE: 'title',
  LOGO: 'logo',
  SEARCH: 'search',
  ADDRESS_BUTTON: 'address_button',
  CART_BUTTON: 'cart_button',
  USER_BUTTON: 'user_button',
};
